import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface EmspBoRfidBadgeOrderListPaidAtCellProps
  extends CellContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['paidAt']
  > {}

export const EmspBoRfidBadgeOrderListPaidAtCell = (
  props: EmspBoRfidBadgeOrderListPaidAtCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  const value = getValue();

  return <Text truncate>{value ? formatDate(value, i18n) : '—'}</Text>;
};
